<mat-dialog-content class="dialog_content">
    <!-- Dialog title - only shown when calendar is displayed -->
    <div *ngIf="!confirmMode && !(bookingSuccess && !isBooking)" class="dialog-title">
        <h2>{{'global.bookTimeSlot' | translate}}</h2>
        <span class="timezone"> {{'timezone.notice' | translate }}</span>
    </div>

    <!-- Success state overlay - hides everything else -->
    <div *ngIf="bookingSuccess && !isBooking" class="success-overlay">
        <div class="overlay-content">
            <div class="state-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="#10B981" stroke-width="2"/>
                    <path d="M9 12L11 14L15 10" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <h2 class="state-title">{{'calendar.booking_success_title' | translate}}</h2>
            <div class="booking-details">
                <div class="detail-row">
                    <span class="detail-label">{{'calendar.date' | translate}}:</span>
                    <span class="detail-value">{{getSelectedDayKey() | translate}} {{getSelectedDayNumber()}} {{getSelectedMonthKey() | translate}} {{getSelectedYear()}}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">{{'calendar.time' | translate }}:</span>
                    <span class="detail-value">{{ selectedTimeSlot.date | date:'HH:mm':'UTC' }} - {{ getSlotEndTime(selectedTimeSlot) | date:'HH:mm':'UTC'  }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">{{'calendar.place' | translate}}:</span>
                    <span class="detail-value">{{selectedPlace?.longName}}</span>
                </div>
            </div>
            <p class="state-message">{{'calendar.booking_success_message' | translate}}</p>
            
            <!-- Timer and proceed button -->
            <div class="timer-section">
                <div class="countdown-timer">
                    <div class="countdown-circle">
                        <span class="countdown-number">{{countdown}}</span>
                    </div>
                    <p class="countdown-text">{{'calendar.auto_proceed_message' | translate}}</p>
                </div>
                <div class="success-buttons" *ngIf="isPortOnlinePayable(request, cart.currentRequest)">
                    <app-button size="sm" (btnClicked)="proceedToPayment()">
                        {{ data.isChange ? ('close' | translate) : ('calendar.proceed_to_payment' | translate) }}
                    </app-button>
                </div>
            </div>
        </div>
    </div>

    <!-- Confirmation mode overlay - separate step -->
    <div *ngIf="confirmMode && selectedTimeSlot && !bookingSuccess" class="confirmation-overlay">
        <div class="overlay-content">
            
            <!-- Loading state -->
            <div *ngIf="isBooking" class="booking-loading">
                <div class="loading-spinner">
                    <svg class="spinner" width="48" height="48" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                            <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
                            <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
                        </circle>
                    </svg>
                </div>
                <h4 class="loading-title">{{'calendar.booking_in_progress' | translate}}</h4>
                <p class="loading-message">{{'calendar.please_wait' | translate}}</p>
            </div>

            <!-- Error state -->
            <div *ngIf="bookingError && !isBooking" class="booking-error">
                <div class="error-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#EF4444" stroke-width="2"/>
                        <path d="M15 9L9 15M9 9L15 15" stroke="#EF4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <h4 class="error-title">{{'calendar.booking_error_title' | translate}}</h4>
                <p class="error-message">{{bookingError}}</p>
                <div class="state-buttons">
                    <app-button size="sm" class="dialog_close" (btnClicked)="cancelBooking()">
                        {{'global.cancel' | translate}}
                    </app-button>
                    <app-button size="sm" (btnClicked)="retryBooking()">
                        {{'global.retry' | translate}}
                    </app-button>
                </div>
            </div>

            <!-- Initial confirmation state -->
            <div *ngIf="!isBooking && !bookingError" class="booking-confirmation-full">
                <div class="state-icon">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#3B82F6" stroke-width="2"/>
                        <path d="M9 12L11 14L15 10" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                
                <h2 class="state-title">{{'calendar.confirm_booking_title' | translate}}</h2>
                
                <div class="booking-details">
                    <div class="detail-row">
                        <span class="detail-label">{{'calendar.date' | translate}}:</span>
                        <span class="detail-value">{{getSelectedDayKey() | translate}} {{getSelectedDayNumber()}} {{getSelectedMonthKey() | translate}} {{getSelectedYear()}}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{'calendar.time' | translate}}:</span>
                        <span class="detail-value">{{ selectedTimeSlot.date | date:'HH:mm':'UTC' }} - {{ getSlotEndTime(selectedTimeSlot) | date:'HH:mm':'UTC'  }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{'calendar.place' | translate}}:</span>
                        <span class="detail-value">{{selectedPlace?.longName}}</span>
                    </div>
                </div>
                
                <p class="state-message">{{'calendar.confirm_booking_message' | translate}}</p>
                
                <div class="state-buttons">
                    <app-button size="sm" class="dialog_close" (btnClicked)="cancelBooking()">
                        {{'global.cancel' | translate}}
                    </app-button>
                    <app-button size="sm" (btnClicked)="confirmBooking()">
                        {{'global.confirm' | translate}}
                    </app-button>
                </div>
            </div>
        </div>
    </div>

    <!-- Calendar container - hidden when in confirmation or success mode -->
    <div class="calendar-container" *ngIf="!confirmMode && !(bookingSuccess && !isBooking)">
        <!-- Calendar Header -->
        <div class="calendar-header">
            <button type="button" class="nav-button" (click)="previousMonth()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            
            <h2 class="month-title">{{getCurrentMonthKey() | translate}} {{getCurrentYear()}}</h2>
            
            <button type="button" class="nav-button" (click)="nextMonth()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>

        <!-- Calendar Grid -->
        <div class="calendar-grid">
            <!-- Loading overlay -->
            <div *ngIf="isLoadingMonth" class="loading-overlay">
                <div class="loading-spinner">
                    <svg class="spinner" width="24" height="24" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                            <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
                            <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
                        </circle>
                    </svg>
                    <p class="loading-text">{{'calendar.loading_month' | translate}}</p>
                </div>
            </div>
            
            <!-- Days of the week header -->
            <div class="weekdays">
                <div class="weekday" *ngFor="let day of weekDays">{{day | translate}}</div>
            </div>
            
            <!-- Calendar days and timeline -->
            <div class="days-grid">
                <ng-container *ngFor="let calendarDay of calendarDays; let i = index">
                    <!-- Regular calendar day -->
                    <div class="calendar-day"
                         [class.current-month]="calendarDay.isCurrentMonth"
                         [class.other-month]="!calendarDay.isCurrentMonth"
                         [class.today]="calendarDay.isToday"
                         [class.open-day]="calendarDay.isOpenDay && calendarDay.isCurrentMonth"
                         [class.closed-day]="!calendarDay.isOpenDay && calendarDay.isCurrentMonth"
                         [class.past-day]="calendarDay.isPastDay"
                         [class.selected]="selectedDate && calendarDay.date.getTime() === selectedDate.getTime()"
                         [class.availability-high]="calendarDay.availabilityStatus === 'high'"
                         [class.availability-medium]="calendarDay.availabilityStatus === 'medium'"
                         [class.fully-booked]="calendarDay.availabilityStatus === 'none'"
                         (click)="selectDay(calendarDay)">
                        <span class="day-number">{{calendarDay.day}}</span>
                        
                    </div>
                    
                    <!-- Timeline row - appears at the end of the selected day's week -->
                    <div *ngIf="showTimeline && selectedDate && isEndOfSelectedWeek(i)" 
                         class="timeline-row"
                         [class.closing]="timelineClosing">
                        <div class="timeline-content">
                            <div class="timeline-header">
                                <h3>{{getSelectedDayKey() | translate}} {{getSelectedDayNumber()}} {{getSelectedMonthKey() | translate}} {{getSelectedYear()}}</h3>
                                <button type="button" class="close-timeline-btn" (click)="hideTimeline()">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                            
                            <!-- Time slots list -->
                            <div *ngIf="!confirmMode" class="time-slots-container">
                                <div *ngIf="timeSlots.length === 0" class="no-slots">
                                    {{'calendar.timeline.no_slots' | translate}}
                                </div>
                                
                                <div class="time-slots-grid">
                                    <div *ngFor="let timeSlot of timeSlots" 
                                         class="time-slot"
                                         [class.available]="timeSlot.available"
                                         [class.booked]="!timeSlot.available"
                                         [class.limited-spots]="timeSlot.remainingSpots <= 2 && timeSlot.available && timeSlot.maxCapacity > 2"
                                         (click)="selectTimeSlot(timeSlot)">
                                        <div class="time-slot-main">
                                            <span class="time">{{ timeSlot.date | date:'HH:mm':'UTC' }} - {{ getSlotEndTime(timeSlot) | date:'HH:mm':'UTC'  }}</span>
                                            <span class="status" *ngif="!api.env.hideAvailableSpotsInBookingDialog">
                                                <ng-container *ngIf="timeSlot.available">
                                                    <ng-container *ngIf="timeSlot.maxCapacity > 1">
                                                        {{timeSlot.remainingSpots}} / {{timeSlot.maxCapacity}} {{'calendar.timeline.spots_available' | translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="timeSlot.maxCapacity === 1">
                                                        {{'calendar.timeline.available' | translate}}
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngIf="!timeSlot.available">
                                                    {{'calendar.timeline.fully_booked' | translate}}
                                                </ng-container>
                                            </span>
                                        </div>
                                        <div class="booking-indicator" *ngIf="timeSlot.maxCapacity > 1 && !api.env.hideAvailableSpotsInBookingDialog">
                                            <div class="booking-dots">
                                                <div *ngFor="let spot of getBookingDots(timeSlot); let i = index" 
                                                     class="booking-dot"
                                                     [class.booked]="i < timeSlot.bookedCount"
                                                     [class.available]="i >= timeSlot.bookedCount">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="dialog-actions" *ngIf="!confirmMode && !(bookingSuccess && !isBooking)">
        <app-button size="sm" class="dialog_close" (btnClicked)="closeDialog()">
            {{'global.close' | translate}}
        </app-button>
    </div>
</mat-dialog-content>